import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Container, Text, Flex } from "@chakra-ui/react";
import OfferCard from "../coupons/OfferCard";
const DEFAULT_COLORS = {
    primary: "#8155FE",
    text: "white",
};
const VenueOffers = ({ offers, pubId, pubColors, }) => {
    var _a, _b;
    const colors = {
        primary: (_a = pubColors === null || pubColors === void 0 ? void 0 : pubColors.primary) !== null && _a !== void 0 ? _a : DEFAULT_COLORS.primary,
        text: (_b = pubColors === null || pubColors === void 0 ? void 0 : pubColors.text) !== null && _b !== void 0 ? _b : DEFAULT_COLORS.text,
    };
    if (offers.length === 0) {
        return null;
    }
    return (_jsxs(_Fragment, { children: [_jsx(Box, { w: "100%", bg: "transparent", py: 8, position: "relative", zIndex: 10, display: { base: "block", md: "none" }, children: _jsxs(Container, { maxW: "container.sm", p: 0, children: [_jsx(Text, { px: 5, textTransform: "uppercase", letterSpacing: 0.5, fontSize: "25", fontWeight: 500, color: colors.text, children: "OFFERS" }), _jsx(Flex, { overflowX: "auto", gap: 3, px: 4, py: 4, css: {
                                "&::-webkit-scrollbar": {
                                    height: "8px",
                                },
                                "&::-webkit-scrollbar-track": {
                                    background: "transparent",
                                },
                                "&::-webkit-scrollbar-thumb": {
                                    background: colors.primary,
                                    borderRadius: "4px",
                                },
                            }, children: offers.map((offer) => (_jsx(Box, { flexShrink: 0, maxW: "300px", children: _jsx(OfferCard, { offer: offer }) }, offer.id))) })] }) }), _jsx(Box, { w: "100%", bg: "transparent", py: [8, 8, 8, 16], position: "relative", zIndex: 10, display: { base: "none", md: "block" }, children: _jsx(Container, { maxW: "container.xl", p: 0, children: _jsxs(Box, { children: [_jsx(Flex, { alignItems: "flex-end", mb: 4, px: 5, pr: 4, children: _jsx(Text, { fontSize: "30", fontWeight: 500, textTransform: "uppercase", letterSpacing: 0.5, color: colors.text, children: "OFFERS" }) }), _jsx(Box, { display: "flex", justifyContent: "center", px: 5, children: _jsx(Flex, { overflowX: "auto", gap: 3, py: 2, css: {
                                        "&::-webkit-scrollbar": {
                                            height: "8px",
                                        },
                                        "&::-webkit-scrollbar-track": {
                                            background: "transparent",
                                        },
                                        "&::-webkit-scrollbar-thumb": {
                                            background: colors.primary,
                                            borderRadius: "4px",
                                        },
                                    }, children: offers.map((offer) => (_jsx(Box, { flexShrink: 0, maxW: "300px", children: _jsx(OfferCard, { offer: offer }) }, offer.id))) }) })] }) }) })] }));
};
export default VenueOffers;
